import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolboxModule } from '../shared/toolbox/toolbox.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExplorerComponent } from './explorer/explorer.component';
import { CardComponent } from './card/card.component';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {LoaderComponent} from '../shared/toolbox/loader/loader.component';
import { SearchComponent } from '../shared/toolbox/search/search.component';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import {
    TabularDataDownloadDialogComponent
} from "../shared/toolbox/dialogs/tabular-data-download-dialog/tabular-data-download-dialog.component";

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@NgModule({
  declarations: [ExplorerComponent, CardComponent],
    imports: [
        LoaderComponent,
        SearchComponent,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ToolboxModule,
        MatIconModule,
        MatSelectModule,
        MatFormFieldModule,
        MatPaginatorModule,
        MatSnackBarModule,
        ToolboxModule,
        MatTooltipModule,
        TabularDataDownloadDialogComponent,
        MatProgressSpinnerModule
    ],
  exports: [ExplorerComponent, CardComponent],
})
export class ExploreModule {}
